<template>
    <div id="car-search">
        <div style="height: 55px;background-color: #fff;margin-bottom: 20px;"></div>
        <div class="main">
            <div class="title">
                <h1>查看您的车灯升级案例</h1>
                <div class="search-box">
                    <div class="element" @click="getBrand()">
                        <input type="text"
                               placeholder="请选择品牌"
                               v-model="carName"
                               class="search">
                        <i class="el-icon-caret-bottom"></i>
                    </div>
                    <div class="element" @click="getModel()">
                        <input type="text"
                               placeholder="请选择车系"
                               v-model="audi"
                               class="search">
                        <i class="el-icon-caret-bottom"></i>
                    </div>
                    <div class="element" @click="toYear()">
                        <input type="text"
                               placeholder="请选择年份"
                               v-model="year"
                               class="search">
                        <i class="el-icon-caret-bottom"></i>
                    </div>
                    <div class="element">
                        <input type="text"
                               v-model="word"
                               @click="searchAll(word)"
                               placeholder="搜索车辆品牌或车系"
                               class="search1">
                        <i class="el-icon-search"></i>
                    </div>
                </div>
            </div>
            <!--选择车名-->
            <main id="brand" @touchstart="scrollCB" class="shadow" v-show="hidden">
                <div class="box">
                    <div class="brand-module" v-for="(brands,d) in brandList"
                         :key="d"
                         v-scrollWatch="{name:brands.id,offset:150,callback:scrollCB}">
                        <p>{{ brands.id }}</p>
                        <div v-for="(brand,b) in brands.brands"
                             :key="b"
                             class="brand-info"
                             @click="toModel(brand.brandLogo,brand.brandId,brand.showName)">
                            <span>
                                <img :src="brand.brandLogo">
                            </span>
                            {{ brand.showName }}
                        </div>
                    </div>
                    <ul class="letter">
                        <li class="bg_white" v-for="(brands,i) in brandList" @click="scrollTo(brands.id)" :key="i">
                            <a :class="{theme:activeIndex==brands.id}">{{ brands.id }}</a>
                        </li>
                    </ul>
                </div>
            </main>
            <!--选择车系-->
            <section id="model" v-show="show" class="shadow">
                <!--<div class="header">
                    <img :src="carLogo" alt="">
                    <span class="car-name">{{carName}}</span>
                </div>-->
                <p class="select-tips">请选择车系</p>
                <div class="model-info icon-more" v-for="(model,m) in modelList" :key="m" @click="toYear(model.modelId,model.modelName)">
                    <p class="info-text">
                        {{ model.modelName }}
                    </p>
                </div>
            </section>
            <!--*******选择年份*******-->
            <section id="year" class="shadow" v-show="toggle">
                <p class="select-tips">请选择年份</p>
                <div class="year-box">
                    <div class="year-info" v-for="(year,y) in yearList" :key="y" @click="toResult(year.carYear)">
                        {{ year.carYear }}
                    </div>
                </div>
            </section>
            <!--********车灯信息*********-->
            <div class="light" v-if="baseInfo">
                <p class="title">车灯信息</p>
                <div class="info">
                   <div class="line">
                       <div class="box">
                           <span class="type">远光灯&nbsp;</span>
                           <span class="name">{{baseInfo.yuanDeng || '无'}}&nbsp;{{baseInfo.yuanDengName}}</span>
                       </div>
                       <div class="box">
                           <span class="type">雾光灯&nbsp;</span>
                           <span class="name">{{baseInfo.wuDeng || '无'}}&nbsp;{{baseInfo.wuDengName}}</span>
                       </div>
                       <div class="box">
                           <span class="type">倒车灯&nbsp;</span>
                           <span class="name">{{baseInfo.daoDeng || '无'}}&nbsp;{{baseInfo.daoDengName}}</span>
                       </div>
                       <div class="box">
                           <span class="type">阅读灯&nbsp;</span>
                           <span class="name">{{baseInfo.yueDeng || '无'}}&nbsp;{{baseInfo.yueDengName}}</span>
                       </div>
                       <div class="box" style="width: 240px;">
                           <span class="type">解码器&nbsp;</span>
                           <span class="name">{{baseInfo.jieMa || '无'}}</span>
                       </div>
                   </div>
                   <div class="line mt47">
                       <div class="box">
                           <span class="type">近光灯&nbsp;</span>
                           <span class="name">{{baseInfo.jinDeng || '无'}}&nbsp;{{baseInfo.jinDengName}}</span>
                       </div>
                       <div class="box">
                           <span class="type">转向灯&nbsp;</span>
                           <span class="name">{{baseInfo.zhuanDeng || '无'}}&nbsp;{{baseInfo.zhuanDengName}}</span>
                       </div>
                       <div class="box">
                           <span class="type">刹车灯&nbsp;</span>
                           <span class="name">{{baseInfo.shaDeng || '无'}}&nbsp;{{baseInfo.shaDengName}}</span>
                       </div>
                       <div class="box">
                           <span class="type">示宽灯&nbsp;</span>
                           <span class="name">{{baseInfo.shiDeng || '无'}}&nbsp;{{baseInfo.shiDengName}}</span>
                       </div>
                       <div class="box" style="width: 240px;">
                           <span class="type">底座&nbsp;&nbsp;&nbsp;&nbsp;</span>
                           <span class="name">{{baseInfo.diZuo || '无'}}</span>
                       </div>
                   </div>
               </div>
                <button @click="$router.push('/install/scanInstall')">预约安装</button>
            </div>
            <!--**********视频展示******-->
            <!--<div class="video" v-if="!shareList.group.length">-->
                <!--<ul class="item-box">-->
                    <!--<li class="item" v-for="(item,index) in choiceList" :key="index" style="background-color: #fff;">-->
                        <!--<img v-if="item.shareType == 'VIDEO'" :src="item.frontUrl" alt="" class="img" @click="flag = index">-->
                        <!--<img v-else :src="item.imgUrls[0]" alt="">-->
                        <!--<div class="master" v-if="flag === index " @click="flag = -1">-->
                          <!--<video controls="controls" height="600">-->
                            <!--<source :src="item.oldVideoUrl" type="video/mp4">-->
                            <!--&lt;!&ndash;<p class="close" @click="flag !== index">X</p>&ndash;&gt;-->
                            <!--您的浏览器不支持 video 标签。请升级或更换您的浏览器</video>-->
                        <!--</div>-->
                        <!--<div class="content">-->
                            <!--<div class="icon"></div>-->
                            <!--<p class="text">{{item.shareContent}}</p>-->
                        <!--</div>-->
                        <!--<div class="user">-->
                            <!--<div class="left">-->
                                <!--<img :src="item.headImgUrl" alt="">-->
                                <!--<p class="user-name">{{item.userName}}</p>-->
                            <!--</div>-->
                            <!--<div class="right">-->
                                <!--<span>点赞</span>-->
                                <!--<span>评论</span>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</div>-->
            <div class="video" v-if="shareList.group.length">
                <ul class="item-box">
                    <li class="item" v-for="(item,index) in shareList.group" :key="index" style="background-color: #fff;">
                        <img v-if="item.shareType == 'VIDEO'" :src="item.frontUrl" alt="" class="img" @click="flag = index">
                        <pic-group v-else :imgs="item.imgUrls" @imgView="imgView(item.imgUrls)"></pic-group>
                          <div class="master" v-if="picture" @click="back()">
                            <div class="bg">
                              <swiper :options="swiperOption">
                                <swiper-slide v-for="(item,index) in imgs" :key="index">
                                  <img :src="item" class="img-item">
                                </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                              </swiper>
                            </div>
                          </div>
                        <div class="master" v-if="flag === index " @click="flag = -1">
                        <video controls="controls" height="600">
                          <source :src="item.oldVideoUrl" type="video/mp4">
                          <!--<p class="close" @click="flag !== index">X</p>-->
                          您的浏览器不支持 video 标签。请升级或更换您的浏览器</video>
                      </div>
                        <div class="content">
                            <div class="icon"></div>
                            <p class="text">{{item.shareContent}}</p>
                        </div>
                        <div class="user">
                            <div class="left">
                                <img :src="item.headImgUrl || installer" alt="">
                                <p class="user-name">{{item.userName}}</p>
                            </div>
                            <div class="right">
                                <span>点赞</span>
                                <span>评论</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="normal" v-else>此车型暂无案例</div>
        </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import picGroup from '../common/picGroup.vue'
import scrollWatch from 'vue-scrollwatch'
export default {
  name: 'carSearch',
  data () {
    return {
      flag: -1,
      msg: '车型查询',
      // 查询车相关
      brandList: [],
      activeIndex: 'A',
      modelList: [],
      carName: '',
      audi: '',
      year: '',
      word: '',
      yearList: [],
      hidden: false,
      show: false,
      toggle: false,
      // 视频相关
      installer: require('../../assets/image/installer.png'),
      baseInfo: null,
      shareList: {
        group: [],
        page: 2
      },
      choiceList: {},
      picture: false,
      // 轮播图
      imgs: [],
      swiperOption: {
        initialSlide: 0,
        updateOnImagesReady: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        }
      }
    }
  },
  computed: {
  },
  created () {
    scrollWatch.setContainer('#brand')
    let that = this
    that.axios.post('../api/wxcar/getShareList', {
      page: 1,
      pageSize: 8,
      orderBy: 'view'
    }, {
      emulateJSON: true
    }).then(function (response) {
      if (response.data.status === 0) {
        that.shareList.group = response.data.value.shareList
      } else {
        that.$store.commit('setToastMsg', response.data.msg)
      }
    }, function (response) {
      that.$store.commit('setToastMsg', '网络错误')
    })
  },
  mounted: function (s) {
  },
  methods: {
    scrollCB: function (node) {
      if (this.activeIndex !== node.name) {
        this.activeIndex = node.name
      }
    },
    scrollTo: function (name) {
      scrollWatch.scrollTo(name)
    },
    getBrand: function () {
      let that = this
      that.axios.post('../api/wxcar/getBrand', {}, {
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.brandList = response.data.value
          that.hidden = !that.hidden
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }, function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    toModel: function (brandLogo, brandId, brandName) {
      this.carName = brandName
      sessionStorage.setItem('brandId', brandId)
      this.show = true
      this.getModel(brandId)
      this.$emit('setTitle', sessionStorage.getItem('brandName'))
    },
    getModel: function () {
      let that = this
      that.axios.post('../api/wxcar/getModel', {
        brandId: sessionStorage.getItem('brandId')
      }, {
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.modelList = response.data.value
          that.show = true
          // that.hidden = false
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }, function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    toYear: function (modelId, modelName) {
      let that = this
      // that.show = false
      that.toggle = true
      that.audi = modelName
      sessionStorage.setItem('modelName', modelName)
      sessionStorage.setItem('modelId', modelId)
      that.axios.post('../api/wxcar/getYear', {
        modelId: modelId
      }, {
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.yearList = response.data.value
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }, function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    toResult (carYear) {
      let that = this
      that.year = carYear
      that.toggle = false
      that.show = false
      that.hidden = false
      that.axios.post('../api/wxcar/getDetail', {
        modelId: sessionStorage.getItem('modelId'),
        carYear: carYear
      }, {
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.baseInfo = response.data.value.baseInfo
          that.shareList.group = response.data.value.shareList || []
          that.axios.post('../api/wxcar/getShareList', {
            modelId: sessionStorage.getItem('modelId'),
            carYear: carYear,
            page: 1,
            pageSize: 8
          }, {
            emulateJSON: true
          }).then(function (response) {
            if (response.data.status === 0) {
              that.shareList.group = response.data.value.shareList
              console.log(that.shareList.group)
            } else {
              that.$store.commit('setToastMsg', response.data.msg)
            }
          }, function (response) {
            that.$store.commit('setToastMsg', '网络错误')
          })
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }, function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    imgView: function (imgs) {
      this.picture = true
      this.$store.commit('setPictures', {imgs: imgs})
      this.imgs = this.$store.getters.getPictures.imgs
      this.swiperOption.initialSlide = this.$store.getters.getPictures.index
      // this.$router.push('/install/picture')
    },
    back () {
      this.picture = false
    },
    searchAll (word) {
    }
  },
  filters: {
  },
  components: {
    swiper,
    swiperSlide,
    picGroup
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*阴影*/
    .shadow{
        -webkit-box-shadow: #b9b9b9 0 0 0.15rem;
        -moz-box-shadow: #b9b9b9 0 0 0.15rem;
        box-shadow: #b9b9b9 0 0 0.15rem;
        /*background: rgba(0,0,0,0.3);*/
    }
    #car-search{
        /*padding: 55px 0;*/
        font-family: "SourceHanSansCN-Normal";
        background-color: #eee;
    }
    .main{
        position: relative;
        height: 100%;
        overflow-y: hidden;
        margin: 0 auto;
        width: 1202px;
        padding: 0 0 49px 0;
    }
    .title{
        width: 1202px;
        height: 321px;
        padding-top: 80px;
        box-sizing: border-box;
        position: relative;
        background-color: #fff;
    }
    /*-------------搜索框样式--------*/
    .element{
        display: inline-block;
        position: relative;
    }
    .search-box{
        margin-top: 49px;
    }
    .search,
    .search1{
        height: 44px;
        line-height: 44px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        font-size: 16px;
        margin-left: 8px;
        padding: 0 15px;
        box-sizing: border-box;
    }
    .search{
        width: 295px;
    }
    .search1{
        width: 218px;
    }
    .el-icon-caret-bottom,
    .el-icon-search{
        color: #dcdfe6;
        position: absolute;
        top: 12px;
        right: 15px;
        font-size: 18px;
    }
    /*----------选择车名样式--------*/
    #brand{
        position: absolute;
        top: 230px;
        left: 0;
        z-index: 3;
        padding: 0 7px 0 3px;
        width: 295px;
        height: 460px;
        overflow-y: scroll;
      overflow-x: hidden;
        /*overflow: hidden;*/
        background-color: #fff;
        box-sizing: border-box;
        margin-left: 35px;
    }
    .box{
    }
    /*.fix{*/
        /*height: 100%;*/
        /*overflow: hidden;*/
    /*}*/
    #brand>div{
        /*padding: 20px 0;*/
        text-align: left;
    }
    .brand-module{
        font-size: 0;
    }
    .brand-module p{
        font-size: 20px;
        color: #b6c5d1;
        background-color: #f7f9fb;
        padding-left: 10px;
        line-height: 30px;
    }
    .brand-info:last-of-type{
        border:none;
    }
    .brand-info{
        font-size: 14px;
        color: #2c2c2c;
        line-height: 46px;
        display: inline-block;
        width: 100%;
        border-bottom: 1px solid #ebebeb;
        padding-left: 15px;
    }
    .brand-info>span{
        display: inline-block;
        width: 30px;
        height: 30px;
        background-image: url(../../assets/image/logo-size.png);
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 3px;
    }
    .brand-info img{
        height: 30px;
        margin-bottom: 10px;
        background-color: #fff;
    }
    .letter{
        width: 40px;
        height: 100%;
        font-size: 18px;
        color: #9b9b9b;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        /*overflow-y: scroll;*/
        z-index: 2;
    }
    .letter>li{
        height: 30px;
        line-height: 30px;
        /*cursor: pointer;*/

    }
    .theme{
        color: #00a16f !important;
    }
    /*----------选择车系样式--------*/
    #model{
        width: 295px;
        height: 460px;
        /*padding: 0 0.3rem;*/
        background-color: #ffffff;
        overflow-y: scroll;
        font-size: 0;
        box-sizing: border-box;
        position: absolute;
        top: 230px;
        left: 340px;
        text-align: left;
        z-index: 2;
    }
    .model-info:last-of-type{
        border:none;
    }
    .model-info{
        padding-left: 15px;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 35px;
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid #ebebeb;
    }
    .model-info .info-text{
        margin-right: 30px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    /*----------选择年份样式--------*/
    #year{
        width: 295px;
        height: 460px;
        overflow-y: scroll;
        position: absolute;
        top: 230px;
        left: 650px;
        background-color: #fff;
        font-size: 0;
        box-sizing: border-box;
        text-align: left;
        z-index: 3;
    }
    .year-info{
        font-size: 14px;
        color: #2c2c2c;
        line-height: 30px;
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid #ebebeb;
        padding-left: 15px;
    }
    .select-tips{
        height: 30px;
        font-size: 14px;
        background-color: #eee;
        color: #999999;
        padding-left: 15px;
        line-height: 30px;
    }
    /*---------------车灯信息样式---------------*/
    .light{
        width: 1202px;
        margin-top: 22px;
        background-color: #fff;
        text-align: left;
        padding-bottom: 41px;
        box-sizing: border-box;
    }
    .light .title{
        width: 100%;
        height: 64px;
        /*line-height: 69px;*/
        padding: 20px 45px;
        box-sizing: border-box;
        color: #333333;
        font-size: 18px;
        font-weight: 600;
        font-family: "SourceHanSansCN-Medium";
        border-bottom: 1px solid #ccc;
    }
    .light .info{
        padding: 54px 45px 62px 45px;
    }
    .light .info .line .box{
        width: 210px;
        float: left;
    }
    .light .info .line .box>span{
        font-size: 14px;
        color: #333333;
        font-family: "SourceHanSansCN-Normal";
    }
    .mt47{
        margin-top: 47px;
    }
    button{
        width: 174px;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        color: #FFFFFF;
        font-family: "SourceHanSansCN-Normal";
        margin-left: 45px;
        background-color: #05b570;
        border-radius: 2px;
    }
    /*----------视频样式--------*/
    .item-box{
        text-align: left;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .item{
        width: 286px;
        height: 350px;
        float: left;
        margin-top: 22px;
        background-color: #fff !important;
    }
    .img{
        width: 286px;
        height: 214px;
    }
    .content{
        padding: 15px;
        box-sizing: border-box;
        border-bottom: 1px solid #ddd;
        overflow: hidden;
    }
    .content .text{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .user{
        display: flex;
        justify-content: space-between;
        padding: 15px;
        box-sizing: border-box;
    }
    .user .left{
        display: flex;
        align-items: center;
    }
    .user .right{
        display: flex;
        align-items: center;
    }
    .user .left .user-name{
        font-size: 12px;
        margin-left: 8px;
    }
    .user .left img{
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }
  video{
    margin: 8% auto;
    height: 70%;
    background-color: #000000;
    display: block;
  }
  .master{
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: fixed;
    background-color: rgba(0,0,0,.5);
    z-index: 666;
  }
  .normal{
    width: 100%;
    height: 160px;
    text-align: center;
    line-height: 260px;
    font-size: 30px;
  }
  /*-----------图片轮播样式-----------*/
    .bg {
      width: 360px;
      height: 560px;
      position: absolute;
      top: 50%;
      left: 50%;
      background-color: #000;
      margin-top: -280px;
      margin-left: -180px;
      z-index: 6666;
    }

    .img-item {
      width: 100%;
    }
</style>
<style>
  .swiper-container {
    height: 100%;
  }

  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 40px;
  }

  .swiper-slide {
    display: flex;
    align-items: center;
  }

  span.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background-color: #666666;
    opacity: 1;
  }

  span.swiper-pagination-bullet-active {
    background-color: #00bf73;
  }
</style>



// WEBPACK FOOTER //
// src/components/install/carSearch.vue